module.exports = __webpack_public_path__ + "static/media/lt_desk_s.a2e741d6.png";